import React from 'react';
import { NotificationsOutlined } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import { styled } from '@mui/material/styles';

const CustomizedNotificationIcon = styled(NotificationsOutlined)({
  fontSize: '30px',
});
const StyledMenu = styled(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(() => ({}));

export { StyledMenu, CustomizedNotificationIcon };
